export const settingsDescriptions: Record<string, string> = {
  // Ticketing
  "ticketing": "Configuration des alertes et notifications système",
  "ticketing.API": "Alertes liées aux appels API",
  "ticketing.API.public": "Erreurs sur l'API publique",
  "ticketing.API.private": "Erreurs sur l'API privée",
  "ticketing.API.llm": "Erreurs sur les appels LLM",
  "ticketing.API.email": "Erreurs sur l'envoi d'emails",
  "ticketing.email": "Gestion des emails",
  "ticketing.email.failed_attachments_rules": "Alerte si pièces jointes non conformes",
  "ticketing.metadata": "Alertes sur les métadonnées extraites",
  "ticketing.metadata.fp": "Faux positifs détectés",
  "ticketing.metadata.ko": "Extraction échouée",
  "ticketing.products": "Alertes sur les produits",
  "ticketing.products.fp": "Produits non reconnus (faux positifs)",
  "ticketing.products.ko": "Erreur de matching produit",
  "ticketing.products.added": "Produits ajoutés manuellement",
  "ticketing.products.deleted": "Produits supprimés",
  "ticketing.status": "Alertes sur les statuts de commande",
  "ticketing.status.archive": "Commandes archivées",
  "ticketing.status.failed": "Commandes en échec",

  // Organization
  "organization": "Informations de l'organisation",
  "organization.name": "Nom de l'organisation (préfixe environnement)",

  // Entities
  "entities": "Liste des entités/sociétés gérées",

  // API
  "api": "Configuration des imports/exports via API",
  "api.general": "Paramètres généraux API",
  "api.general.api_import_activate": "Activer l'import de données via API",
  "api.general.api_export_activate": "Activer l'export de données via API",
  "api.import": "Configuration des imports API",
  "api.import.mailTo_onError": "Emails notifiés en cas d'erreur d'import",
  "api.export": "Configuration des exports API",
  "api.export.products_add_fields_from_bdd": "Champs supplémentaires à exporter depuis la BDD",
  "api.export.product_quantity_packing": "Unité de conditionnement pour export (MOQ/ATOM)",
  "api.export.mailTo_onError": "Emails notifiés en cas d'erreur d'export",

  // ERP
  "erp": "Intégration avec l'ERP",
  "erp.general": "Paramètres généraux ERP",
  "erp.general.erp_import_activate": "Activer l'import depuis l'ERP",
  "erp.general.erp_export_activate": "Activer l'export vers l'ERP",
  "erp.general.erp_export_synchronous": "Export synchrone (bloquant)",
  "erp.import": "Configuration import ERP",
  "erp.import.specificFunctions": "Fonctions spécifiques d'import à exécuter",
  "erp.import.mailTo_onError": "Emails notifiés en cas d'erreur",
  "erp.export": "Configuration export ERP",
  "erp.export.specificFunctions": "Fonctions spécifiques d'export à exécuter",
  "erp.export.mailTo_onError": "Emails notifiés en cas d'erreur",

  // SFTP
  "sftp": "Configuration des échanges SFTP",
  "sftp.general": "Paramètres généraux SFTP",
  "sftp.general.sftp_import_activate": "Activer l'import via SFTP",
  "sftp.general.sftp_export_activate": "Activer l'export via SFTP",
  "sftp.general.erp_export_synchronous": "Export synchrone vers SFTP",
  "sftp.import": "Configuration des imports SFTP",
  "sftp.import.customers": "Import du fichier clients",
  "sftp.import.customers.refFilename": "Nom du fichier de référence",
  "sftp.import.customers.sep_csv": "Séparateur CSV",
  "sftp.import.customers.skip_on_error": "Continuer en cas d'erreur",
  "sftp.import.customers.dedoublon_id": "Dédoublonner par ID",
  "sftp.import.customers.mailTo_onError": "Emails notifiés en cas d'erreur",
  "sftp.import.customers.mailTo_onSuccess": "Emails notifiés en cas de succès",
  "sftp.import.products": "Import du fichier produits",
  "sftp.import.products.refFilename": "Nom du fichier de référence",
  "sftp.import.products.sep_csv": "Séparateur CSV",
  "sftp.import.products.skip_on_error": "Continuer en cas d'erreur",
  "sftp.import.products.dedoublon_id": "Dédoublonner par ID",
  "sftp.import.products.mailTo_onError": "Emails notifiés en cas d'erreur",
  "sftp.import.products.mailTo_onSuccess": "Emails notifiés en cas de succès",
  "sftp.import.specifics": "Import des spécificités produits",
  "sftp.import.specifics.refFilename": "Nom du fichier de référence",
  "sftp.import.specifics.sep_csv": "Séparateur CSV",
  "sftp.import.specifics.skip_on_error": "Continuer en cas d'erreur",
  "sftp.import.specifics.dedoublon_id": "Dédoublonner par ID",
  "sftp.import.specifics.mailTo_onError": "Emails notifiés en cas d'erreur",
  "sftp.import.specifics.mailTo_onSuccess": "Emails notifiés en cas de succès",
  "sftp.export": "Configuration export SFTP",
  "sftp.export.specificFunctions": "Fonctions spécifiques à exécuter",
  "sftp.export.mailTo_onError": "Emails notifiés en cas d'erreur",

  // Web
  "web": "Configuration des webhooks/API web",
  "web.general": "Paramètres généraux web",
  "web.general.web_import_activate": "Activer l'import via webhook",
  "web.general.web_export_activate": "Activer l'export via webhook",
  "web.general.web_export_synchronous": "Export synchrone",
  "web.import": "Configuration import web",
  "web.import.specificFunctions": "Fonctions spécifiques d'import",
  "web.import.mailTo_onError": "Emails notifiés en cas d'erreur",
  "web.export": "Configuration export web",
  "web.export.specificFunctions": "Fonctions spécifiques d'export",
  "web.export.mailTo_onError": "Emails notifiés en cas d'erreur",

  // NLP
  "nlp": "Configuration du traitement du langage naturel",
  "nlp.seuil_occurance": "Seuil entre mot haute et basse fréquence",
  "nlp.seuil_occurance.value": "Valeur du seuil",
  "nlp.seuil_occurance.description": "Description du seuil",
  "nlp.product_color_manual": "Couleurs de produits ajoutées manuellement",
  "nlp.remove_product_color_manual": "Couleurs à exclure du traitement",
  "nlp.product_size_manual": "Tailles de produits reconnues",
  "nlp.remove_product_size_manual": "Tailles à exclure",
  "nlp.product_model_manual": "Modèles de produits reconnus",
  "nlp.remove_product_model_manual": "Modèles à exclure",
  "nlp.product_brand_manual": "Marques reconnues",
  "nlp.remove_product_brand_manual": "Marques à exclure",
  "nlp.product_type_manual": "Types de produits reconnus",
  "nlp.remove_product_type_manual": "Types à exclure",
  "nlp.remove_low_frequency_words": "Mots basse fréquence à ignorer",
  "nlp.synonyme": "Dictionnaire de synonymes",
  "nlp.synonyme.words": "Associations mot -> synonymes",

  // Processing
  "processing": "Configuration du traitement des commandes",
  "processing.retryPolicy": "Politique de retry",
  "processing.retryPolicy.orderProcess_timeout": "Timeout de traitement en minutes",
  "processing.internal": "Configuration interne",
  "processing.internal.env_dev_bucketNameCompany": "Bucket S3 environnement dev",
  "processing.internal.env_staging_bucketNameCompany": "Bucket S3 environnement staging",
  "processing.internal.env_prod_bucketNameCompany": "Bucket S3 environnement production",
  "processing.reprocessing_change_subject_dev": "Changer le sujet email en retraitement (dev)",
  "processing.reprocessing_change_subject_dev.value": "Activer le changement de sujet",
  "processing.reprocessing_change_subject_prod": "Changer le sujet email en retraitement (prod)",
  "processing.reprocessing_change_subject_prod.value": "Activer le changement de sujet",
  "processing.ocr": "Configuration de l'OCR",
  "processing.ocr.method": "Méthodes de traitement OCR",
  "processing.ocr.method.add_header_if_missing": "Ajouter header si manquant",
  "processing.ocr.method.clean_products_page_break": "Nettoyer sauts de page dans produits",
  "processing.ocr.method.product_name_byTable": "Extraire nom produit depuis tableau",
  "processing.ocr.method.detect_if_rebuild_table_lineByLine": "Détecter si reconstruction nécessaire",
  "processing.ocr.method.products_rebuild_table_lineByLine": "Reconstruire tableau ligne par ligne",
  "processing.ocr.method.products_extractionFields_auto_prices": "Extraction automatique des prix",
  "processing.reprocess_onChange_customer": "Retraiter si changement de client",
  "processing.reprocess_onChange_customer.value": "Activer le retraitement",
  "processing.email_body_translation": "Traduction du corps de l'email",
  "processing.email_body_translation.value": "Activer la traduction",
  "processing.email_body_translation.translate_to": "Langue cible",
  "processing.metadata": "Champs de métadonnées à extraire",
  "processing.metadata.extractionFields": "Liste des champs avec leurs propriétés",
  "processing.products": "Configuration extraction produits",
  "processing.products.extractionFields": "Champs produits à extraire",
  "processing.products.specific_units": "Unités spécifiques par type",
  "processing.products.packaging_matching": "Correspondance conditionnements",
  "processing.products.packaging_multiplier": "Multiplicateurs par unité",

  // Matching metadata
  "matching_metadata": "Configuration du matching des métadonnées client",
  "matching_metadata.specificFunctions": "Fonctions de matching à appliquer",
  "matching_metadata.filteredByEntity": "Filtrer les résultats par entité",
  "matching_metadata.filteredByEntity.value": "Activer le filtrage",

  // Matching products
  "matching_products": "Configuration du matching produits",
  "matching_products.specificFunctions": "Stratégies de matching produits",
  "matching_products.filteredByEntity": "Filtrer les produits par entité",
  "matching_products.filteredByEntity.value": "Activer le filtrage",

  // Checks order metadata
  "checks_order_metadata": "Vérifications sur les métadonnées de commande",
  "checks_order_metadata.order_id__formatControl": "Contrôler le format du numéro de commande",
  "checks_order_metadata.order_id__formatControl.value": "Activer le contrôle",
  "checks_order_metadata.id_by_hitl": "Identification client par validation humaine",
  "checks_order_metadata.id_by_hitl.value": "Activer l'identification manuelle",
  "checks_order_metadata.id_by_hitl.bonus": "Points bonus pour confiance",
  "checks_order_metadata.id_by_hitl.candidate_list_hitl": "Liste des candidats et leurs scores",
  "checks_order_metadata.id_skip_by_algo_if_hitl": "Skip algo si validation humaine",
  "checks_order_metadata.id_skip_by_algo_if_hitl.value": "Activer le skip",
  "checks_order_metadata.id_skip_by_algo_if_hitl.threshold": "Seuil de confiance",
  "checks_order_metadata.id_skip_by_algo_if_hitl.algoProposalIfBelowThreshold": "Proposer algo si sous le seuil",
  "checks_order_metadata.id_skip_by_algo_if_hitl.maximumConfidenceIfAlgo": "Confiance max si algo",
  "checks_order_metadata.sender_address_matching": "Matching adresse expéditeur",
  "checks_order_metadata.sender_address_matching.value": "Activer le matching",
  "checks_order_metadata.sender_address_matching.onlyInDeliveryPerCustomer": "Uniquement dans adresses de livraison",
  "checks_order_metadata.sender_address_matching.proposeDefaultIfNoMatch": "Proposer adresse par défaut",
  "checks_order_metadata.sender_address_matching.confidence_proposeDefaultIfNoMatch": "Confiance si défaut",
  "checks_order_metadata.sender_address_matching.confidence_proposeDefaultIfNoMatch_only1_candidate": "Confiance si 1 seul candidat",
  "checks_order_metadata.billing_address_matching": "Matching adresse facturation",
  "checks_order_metadata.billing_address_matching.value": "Activer le matching",
  "checks_order_metadata.billing_address_matching.onlyInDeliveryPerCustomer": "Uniquement dans adresses de livraison",
  "checks_order_metadata.billing_address_matching.proposeDefaultIfNoMatch": "Proposer adresse par défaut",
  "checks_order_metadata.billing_address_matching.confidence_proposeDefaultIfNoMatch": "Confiance si défaut",
  "checks_order_metadata.billing_address_matching.confidence_proposeDefaultIfNoMatch_only1_candidate": "Confiance si 1 seul candidat",
  "checks_order_metadata.delivery_address_matching": "Matching adresse livraison",
  "checks_order_metadata.delivery_address_matching.value": "Activer le matching",
  "checks_order_metadata.delivery_address_matching.onlyInDeliveryPerCustomer": "Uniquement dans adresses connues",
  "checks_order_metadata.delivery_address_matching.proposeDefaultIfNoMatch": "Proposer adresse par défaut",
  "checks_order_metadata.delivery_address_matching.swap_delivery_sender_fromBDC": "Inverser livraison/expédition depuis BDC",
  "checks_order_metadata.delivery_address_matching.confidence_proposeDefaultIfNoMatch": "Confiance si défaut",
  "checks_order_metadata.delivery_address_matching.confidence_proposeDefaultIfNoMatch_only1_candidate": "Confiance si 1 seul candidat",
  "checks_order_metadata.comment_classification": "Types de commentaires à classifier",
  "checks_order_metadata.forbidden_domains": "Domaines emails interdits",
  "checks_order_metadata.forbidden_emails": "Emails spécifiques interdits",

  // Checks order products
  "checks_order_products": "Vérifications sur les produits de la commande",
  "checks_order_products.id_quantity_by_hitl_manual_parsing": "Parsing manuel des quantités",
  "checks_order_products.id_quantity_by_hitl_manual_parsing.value": "Activer le parsing manuel",
  "checks_order_products.id_quantity_by_hitl_manual_parsing.confidence": "Score de confiance",
  "checks_order_products.id_quantity_by_hitl_manual_parsing.dict_rules_customer_manual_parsing": "Règles de parsing par client",
  "checks_order_products.id_by_algo": "Identification produit par algorithme",
  "checks_order_products.id_by_algo.value": "Activer l'identification algo",
  "checks_order_products.id_by_algo.bonus": "Points bonus",
  "checks_order_products.id_skip_by_algo_if_hitl_manual_parsing": "Skip algo si parsing manuel",
  "checks_order_products.id_skip_by_algo_if_hitl_manual_parsing.value": "Activer le skip",
  "checks_order_products.id_skip_by_algo_if_hitl_manual_parsing.threshold": "Seuil de confiance",
  "checks_order_products.id_skip_by_algo_if_hitl_manual_parsing.algoProposalIfBelowThreshold": "Proposer algo si sous seuil",
  "checks_order_products.id_skip_by_algo_if_hitl_manual_parsing.maximumConfidenceIfAlgo": "Confiance max algo",
  "checks_order_products.id_by_hitl_parsing": "Parsing par apprentissage",
  "checks_order_products.id_by_hitl_parsing.value": "Activer le parsing HITL",
  "checks_order_products.id_by_hitl_parsing.bonus": "Points bonus",
  "checks_order_products.id_by_hitl_parsing.minimum_occurence_ALL": "Occurrences min pour tous produits",
  "checks_order_products.id_by_hitl_parsing.minimum_ratio_ALL": "Ratio min pour tous produits",
  "checks_order_products.id_by_hitl_parsing.confidenceByALLProducts": "Confiance si tous produits",
  "checks_order_products.id_by_hitl_parsing.minimum_occurence_HINT": "Occurrences min avec indice",
  "checks_order_products.id_by_hitl_parsing.minimum_ratio_HINT": "Ratio min avec indice",
  "checks_order_products.id_by_hitl_parsing.confidenceByHINTProducts": "Confiance avec indice",
  "checks_order_products.id_by_hitl": "Validation humaine produit",
  "checks_order_products.id_by_hitl.value": "Activer validation humaine",
  "checks_order_products.id_by_hitl.bonus": "Points bonus",
  "checks_order_products.id_skip_by_algo_if_hitls": "Skip algo si validations humaines",
  "checks_order_products.id_skip_by_algo_if_hitls.value": "Activer le skip",
  "checks_order_products.id_skip_by_algo_if_hitls.threshold": "Seuil de confiance",
  "checks_order_products.id_skip_by_algo_if_hitls.algoProposalIfBelowThreshold": "Proposer algo si sous seuil",
  "checks_order_products.id_skip_by_algo_if_hitls.maximumConfidenceIfAlgo": "Confiance max algo",
  "checks_order_products.id_skip_by_algo_if_hitls.onlyWithCustomers": "Clients concernés uniquement",
  "checks_order_products.id_skip_by_algo_if_hitls.skipIfNotHitlParsingFile": "Skip si pas de fichier parsing",
  "checks_order_products.quantity_by_multiplier": "Calculer quantité via multiplicateur",
  "checks_order_products.quantity_by_multiplier.value": "Activer le calcul",
  "checks_order_products.quantity_by_packing": "Quantité via conditionnement",
  "checks_order_products.quantity_by_packing.value": "Activer calcul par conditionnement",
  "checks_order_products.quantity_by_packing.bonus": "Points bonus",
  "checks_order_products.quantity_skip_by_algo_if_hitl_manual_parsing": "Skip algo quantité si parsing manuel",
  "checks_order_products.quantity_skip_by_algo_if_hitl_manual_parsing.value": "Activer le skip",
  "checks_order_products.quantity_skip_by_algo_if_hitl_manual_parsing.threshold": "Seuil de confiance",
  "checks_order_products.quantity_skip_by_algo_if_hitl_manual_parsing.algoProposalIfBelowThreshold": "Proposer algo si sous seuil",
  "checks_order_products.quantity_skip_by_algo_if_hitl_manual_parsing.maximumConfidenceIfAlgo": "Confiance max algo",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing": "Skip algo quantité si parsing HITL",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.value": "Activer le skip",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.threshold": "Seuil de confiance",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.algoProposalIfBelowThreshold": "Proposer algo si sous seuil",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.maximumConfidenceIfAlgo": "Confiance max algo",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.onlyWithCustomers": "Clients concernés uniquement",
  "checks_order_products.quantity_skip_by_algo_if_hitl_parsing.skipIfNotHitlParsingFile": "Skip si pas de fichier",
  "checks_order_products.quantity_force_control_above_atom": "Forcer contrôle si quantité élevée",
  "checks_order_products.quantity_force_control_above_atom.threshold": "Seuil quantité atoms",
  "checks_order_products.quantity_force_control_above_atom.threshold_skip_by_algo_if_hitl_parsing": "Seuil skip algo",
  "checks_order_products.quantity_force_control_above_atom.threshold_hitl_parsing": "Seuil parsing HITL",
  "checks_order_products.quantity_force_control_above_atom.threshold_hitl_manual_parsing": "Seuil parsing manuel",
  "checks_order_products.quantity_by_hitl_parsing": "Quantité par apprentissage",
  "checks_order_products.quantity_by_hitl_parsing.value": "Activer parsing quantité",
  "checks_order_products.quantity_by_hitl_parsing.bonus": "Points bonus",
  "checks_order_products.quantity_by_hitl_parsing.minimum_occurence_PRODUCT": "Occurrences min par produit",
  "checks_order_products.quantity_by_hitl_parsing.minimum_ratio_PRODUCT": "Ratio min par produit",
  "checks_order_products.quantity_by_hitl_parsing.confidenceByProduct": "Confiance par produit",
  "checks_order_products.quantity_by_hitl_parsing.minimum_occurence_ALL": "Occurrences min tous produits",
  "checks_order_products.quantity_by_hitl_parsing.minimum_ratio_ALL": "Ratio min tous produits",
  "checks_order_products.quantity_by_hitl_parsing.confidenceByALLProducts": "Confiance tous produits",
  "checks_order_products.quantity_by_hitl_parsing.minimum_occurence_HINT": "Occurrences min avec indice",
  "checks_order_products.quantity_by_hitl_parsing.minimum_ratio_HINT": "Ratio min avec indice",
  "checks_order_products.quantity_by_hitl_parsing.confidenceByHINTProducts": "Confiance avec indice",
  "checks_order_products.quantity_by_hitl_parsing.checkPrice": "Vérifier cohérence prix",
  "checks_order_products.quantity_by_hitl": "Quantité par validation humaine",
  "checks_order_products.quantity_by_hitl.value": "Activer validation quantité",
  "checks_order_products.quantity_by_hitl.bonus": "Points bonus",
  "checks_order_products.quantity_by_price": "Quantité déduite du prix",
  "checks_order_products.quantity_by_price.value": "Activer calcul par prix",
  "checks_order_products.quantity_by_price.bonus": "Points bonus",
  "checks_order_products.quantity_defaultConfidence": "Confiance par défaut quantité",
  "checks_order_products.quantity_defaultConfidence.value": "Score de confiance",
  "checks_order_products.quantity_defaultConfidence.bonus": "Points bonus",
  "checks_order_products.quantity_defaultConfidence.forceValueToInteger": "Forcer en entier",
  "checks_order_products.quantity_defaultConfidence_emailBody": "Confiance quantité depuis email",
  "checks_order_products.quantity_defaultConfidence_emailBody.value": "Score de confiance",
  "checks_order_products.quantity_defaultConfidence_emailBody.bonus": "Points bonus",
  "checks_order_products.quantity_defaultConfidence_emailBody.forceValueToInteger": "Forcer en entier",
  "checks_order_products.quantity_below1_forcePacking": "Forcer conditionnement si <1",
  "checks_order_products.quantity_below1_forcePacking.value": "Activer la règle",
  "checks_order_products.quantity_below1_forcePacking.referenceUnit": "Unité de référence",
  "checks_order_products.quantity_below1_forcePacking.detail": "Description de la règle",
  "checks_order_products.quantity_moq_mandatory": "MOQ obligatoire",
  "checks_order_products.quantity_moq_mandatory.value": "Interdire le déconditionnement",
  "checks_order_products.quantity_moq_mandatory.detail": "Description de la règle",
  "checks_order_products.quantity_moq_verification": "Vérifier respect des MOQ",
  "checks_order_products.quantity_moq_verification.value": "Activer la vérification",
  "checks_order_products.quantity_0_notAllow": "Interdire quantité zéro",
  "checks_order_products.quantity_0_notAllow.value": "Activer l'interdiction",
  "checks_order_products.quantity_0_removed": "Supprimer lignes quantité zéro",
  "checks_order_products.quantity_0_removed.value": "Activer la suppression",
  "checks_order_products.quantity_forceValueToInteger": "Forcer toutes quantités en entier",
  "checks_order_products.quantity_forceValueToInteger.value": "Activer le forçage",
  "checks_order_products.price_detection": "Activer détection des prix",
  "checks_order_products.price_detection.value": "Activer la détection",
  "checks_order_products.product_inReferential": "Vérifier présence dans référentiel",
  "checks_order_products.product_inReferential.value": "Activer la vérification",
  "checks_order_products.product_doublon": "Détecter les doublons produits",
  "checks_order_products.product_doublon.value": "Activer la détection",
  "checks_order_products.warningOcrPdf": "Avertissement qualité OCR",
  "checks_order_products.warningOcrPdf.value": "Activer les avertissements",
  "checks_order_products.warningOcrPdf.whiteList": "Clients en liste blanche",
  "checks_order_products.warningOcrPdf.blackList": "Clients en liste noire",
  "checks_order_products.variant_force_verification": "Forcer vérification des variantes",
  "checks_order_products.variant_force_verification.value": "Activer la vérification",
  "checks_order_products.forbidden_words": "Mots interdits dans les produits",
  "checks_order_products.manualSpecifics": "Spécificités manuelles produits",
  "checks_order_products.manualSpecifics.value": "Dictionnaire ID -> spécificités",
  "checks_order_products.manualSpecifics.description": "Ajouter des product_id_specifics pour tous clients",

  // Checks order process
  "checks_order_process": "Configuration du processus de traitement",
  "checks_order_process.entityMatching": "Matching des entités",
  "checks_order_process.entityMatching.automaticMatching": "Matching automatique des entités",
  "checks_order_process.entityMatching.defaultEntityConfidenceIfNoMatching": "Confiance par défaut si pas de match",
  "checks_order_process.entityMatching.emailMatching": "Matcher par email",
  "checks_order_process.assignment": "Attribution des commandes",
  "checks_order_process.assignment.method": "Méthode d'attribution (par groupe client)",
  "checks_order_process.emailReply": "Réponses email automatiques",
  "checks_order_process.emailReply.replySystemAfterOrderSend_success": "Répondre si succès",
  "checks_order_process.emailReply.replySystemAfterOrderSend_pending_review": "Répondre si en révision",
  "checks_order_process.emailReply.replySystemAfterOrderSend_failed": "Répondre si échec",
  "checks_order_process.attachments": "Gestion des pièces jointes",
  "checks_order_process.attachments.pdf": "Accepter PDF",
  "checks_order_process.attachments.jpg": "Accepter JPG",
  "checks_order_process.attachments.png": "Accepter PNG",
  "checks_order_process.attachments.xls": "Accepter Excel",
  "checks_order_process.attachments.pdf_quantity_allowed": "Nombre max de PDF",
  "checks_order_process.attachments.jpg_quantity_allowed": "Nombre max de JPG",
  "checks_order_process.attachments.png_quantity_allowed": "Nombre max de PNG",
  "checks_order_process.attachments.max_number_attachments_toProcess": "Nombre max de pièces jointes",
  "checks_order_process.attachments.max_number_orders_inPdf": "Nombre max de commandes par PDF",
  "checks_order_process.allowedOrderInBody": "Autoriser commande dans corps email",
  "checks_order_process.force_pending_status_automation": "Forcer statut pending si automatisation",
  "checks_order_process.notWorkingDay": "Jours non travaillés (0=dim, 6=sam)",
  "checks_order_process.update_BDC_checkProductInRef": "Vérifier produit dans référentiel pour mise à jour BDC",

  // Display
  "display": "Configuration de l'affichage et des fonctionnalités",
  "display.system": "Paramètres système",
  "display.system.env_prod": "Environnement de production",
  "display.features": "Fonctionnalités disponibles",
  "display.features.ack_update": "Mise à jour des accusés de réception",
  "display.features.entity": "Gestion des entités",
  "display.features.database": "Accès à la base de données",
  "display.features.review_parsing": "Révision du parsing",
  "display.product_quantity": "Configuration des quantités produits",
  "display.product_quantity.atom": "Afficher l'unité atom",
  "display.product_quantity.label_for_atom": "Label personnalisé pour atom",
  "display.product_quantity.moq": "Afficher l'unité MOQ",
  "display.product_quantity.label_for_moq": "Label personnalisé pour MOQ",
  "display.product_quantity.delivery": "Afficher l'unité delivery",
  "display.product_quantity.label_for_delivery": "Label personnalisé pour delivery",
  "display.product_quantity.authorize_unpacking": "Autoriser le déconditionnement",
  "display.product_quantity.template": "Template d'affichage des quantités",
  "display.product_quantity.unit_by_default": "Unité par défaut sélectionnée",
  "display.product_select": "Configuration de la sélection produits",
  "display.product_select.product_name_caps": "Nom produit en majuscules",
  "display.product_select.product_id_caps": "ID produit en majuscules",
  "display.product_select.product_packing_in_name": "Afficher conditionnement dans le nom",
  "display.product_display_column": "Colonnes d'affichage produits",
  "display.product_display_column.variant": "Afficher colonne variante",
  "display.product_display_column.price": "Afficher colonne prix",
  "display.custom_message": "Messages personnalisés",
  "display.custom_message.archive": "Message lors de l'archivage"
};

export function getSettingDescription(path: string): string {
  return settingsDescriptions[path] || '';
}